import React from "react";
import ReactPlayer from "react-player";
import video from "../../assets/videos/PIE-Prueba.mp4";

const Player = () => {
  return <ReactPlayer className="reproductor" url={video} controls={true} />;
};

export default Player;
